import { createSvgIcon } from "@mui/material";

export default createSvgIcon(
  <svg
    width={23}
    height={17}
    viewBox="0 0 23 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Subtract"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23 0H0V17H23V0ZM6.73223 4.73223C7.20107 4.26339 7.83696 4 8.5 4C8.8283 4 9.15339 4.06466 9.45671 4.1903C9.76002 4.31594 10.0356 4.50009 10.2678 4.73223C10.4999 4.96438 10.6841 5.23998 10.8097 5.54329C10.9353 5.84661 11 6.1717 11 6.5C11 6.8283 10.9353 7.15339 10.8097 7.45671C10.6841 7.76002 10.4999 8.03562 10.2678 8.26777C10.0356 8.49991 9.76002 8.68406 9.45671 8.8097C9.15339 8.93534 8.8283 9 8.5 9C7.83696 9 7.20107 8.73661 6.73223 8.26777C6.50009 8.03562 6.31594 7.76002 6.1903 7.45671C6.06466 7.15339 6 6.8283 6 6.5C6 5.83696 6.26339 5.20107 6.73223 4.73223ZM13.5 12.75V14H3.5V12.75C3.5 11.09 6.84 10.25 8.5 10.25C10.16 10.25 13.5 11.09 13.5 12.75ZM13.5 4V5H19.5V4H13.5ZM13.5 6H19.5V7H13.5V6ZM13.5 8V9H17.5V8H13.5Z"
      fill="#222A5C"
    />
  </svg>,
  "ProfileFilled"
);
